import {stbarthrental} from "@/shared/data";

export const state = {
    adCar: stbarthrental[0],
    currencies: null,
    currency : null,
    locale: 'fr',
    auth: {
        loggedUser: null,
        accessToken: null
    },
    alert: null,
    buildTime: 0,
    appVersion: null,
    appName: null,
    uiConf: null,
};
